import { render, staticRenderFns } from "./Follow.vue?vue&type=template&id=5376cc75&scoped=true&"
import script from "./Follow.vue?vue&type=script&lang=js&"
export * from "./Follow.vue?vue&type=script&lang=js&"
import style0 from "./Follow.vue?vue&type=style&index=0&id=5376cc75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5376cc75",
  null
  
)

export default component.exports